/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ domain: NonNullable<unknown> }} Chat_Tool_Confirm_Revokes_DomainInputs */



/**
* | output |
* | --- |
* | "Its custom domain {domain} is removed now and has to be claimed again after a restore." |
*
* @param {Chat_Tool_Confirm_Revokes_DomainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_revokes_domain = /** @type {((inputs: Chat_Tool_Confirm_Revokes_DomainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Revokes_DomainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die eigene Domain ${i?.domain} wird sofort entfernt und muss nach dem Wiederherstellen neu eingerichtet werden.`)
	return /** @type {LocalizedString} */ (`Its custom domain ${i?.domain} is removed now and has to be claimed again after a restore.`)
});